import client from '@/api/client';

interface UpdateCompanySettingsParams {
    CompanyId: string;
    DemoMeeting?: boolean;
    StartupMeeting?: boolean;
    Comment?: string;
}

interface CompanySettingsResponse {
    DemoMeeting: boolean;
    StartupMeeting: boolean;
    Comment: string | null;
}

const updateCompanySettings = ({ CompanyId, ...fields }: UpdateCompanySettingsParams): Promise<CompanySettingsResponse> =>
    client.put<CompanySettingsResponse>(`/superadmin/companies/${CompanyId}/settings`, fields).then(res => res.data);

export default updateCompanySettings;
